module.exports = __webpack_public_path__ + "static/media/practitioner_icon.45ba7f2a.svg";